module.exports = __webpack_public_path__ + "static/media/GeoTagIcon.f0d0a1c4.svg";